import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
  LOGIN_REQUEST = 'react/auth0/LOGIN_REQUEST',
  LOGIN_SUCCESS = 'react/auth0/LOGIN_SUCCESS',
  LOGIN_ERROR = 'react/auth0/LOGIN_ERROR',
  LOGOUT = 'react/auth0/LOGOUT_SUCCESS',
  OTHER_ACTION = 'react/auth0/__any_other_action__',
}


export type Types = IBaseAction<Keys>;